module.exports = __webpack_public_path__ + "static/media/icon-complete.037bd768.svg";